import { currency, decimal, type CurrencyCode } from '@/shared/lib/format';
import type { CatalogProduct } from '../model/operator-payload';
import { catalogCost, catalogBillDiscount } from '../model/operator-payload';
import type { OperatorProgram } from '../model/operator-rules';
import type { Passbook } from '@/shared/types';

export function isCatalogProductEnabled(p: CatalogProduct): boolean {
  const e = p.enabled;
  if (e === false || e === 'false') return false;
  return true;
}

function formatCatalogCost(cost: number, program: OperatorProgram, currencyCode: CurrencyCode): string {
  if (program === 'cashback' || program === 'giftcard' || program === 'balance') {
    return currency(cost, currencyCode);
  }
  if (program === 'stamps') {
    return `${decimal(cost)} ${cost === 1 ? 'selo' : 'selos'}`;
  }
  return `${decimal(cost)} pts`;
}

/**
 * Label do item no catálogo.
 * discount: name + abate desconto em R$ + custa `costText` (pts/selos).
 * Ex.: "Vale 20 — desconto R$ 20,00 · 10 selos"
 */
export function catalogProductLabel(
  p: CatalogProduct,
  currencyCode: CurrencyCode,
  program: OperatorProgram,
  passbook?: Passbook,
): string {
  const cost = catalogCost(p, passbook);
  const costText = formatCatalogCost(cost, program, currencyCode);
  const type = (p.redemptionType ?? 'product').toLowerCase();
  if (type === 'discount') {
    const discount = catalogBillDiscount(p, passbook);
    return `${p.name} — desconto ${currency(discount, currencyCode)} · ${costText}`;
  }
  return `${p.name} — ${costText}`;
}
